export const sortOptions = [
  { label: "A-Z Alphabets", value: "alphabetical" },
  { label: "Ascending", value: "asc" },
  { label: "Descending", value: "desc" },
  { label: "Recently Added", value: "recentlyAdded" },
];
